export default class ProactiveUnderPerformingKeywordValidationState {
    public hasUnderPerformingKeywords = false;
    public hasFiles = false;
    public hasNote = false;
    public hasGottenKeywordsResponse = false;
    public hasGottenChecklistResponse = false;
}